/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BannerClassStudents200,
  GetApiV1BannerClassStudents401,
  GetApiV1BannerClassStudents500,
  GetApiV1BannerClassStudentsQueryParams,
  GetApiV1BannerClassStudentsQueryResponse,
} from "../../types/bannerRegistroController/GetApiV1BannerClassStudents.ts";
import { bannerClassStudentDropDownViewModelPaginatedResponseSchema } from "../bannerClassStudentDropDownViewModelPaginatedResponseSchema.ts";

export const getApiV1BannerClassStudentsQueryParamsSchema = z
  .object({
    Filter: z.optional(
      z
        .string()
        .describe(
          "Texto para filtrar por descrição ou código da turma. Opcional.",
        ),
    ),
    BrandIds: z.optional(
      z
        .array(z.coerce.number().int())
        .describe(
          "IDs de marca para restringir o resultado. Informe o parâmetro uma ou mais vezes (ex: ?brandIds=1&brandIds=2). Nulo retorna turmas de todas as marcas. Opcional.",
        ),
    ),
    ActiveOnly: z.optional(
      z
        .boolean()
        .describe(
          "Quando true (padrão), retorna apenas turmas ativas e com data início ≤ hoje ≤ data fim.",
        ),
    ),
    Page: z.optional(
      z.coerce.number().int().describe("Número da página (base 1). Padrão: 1."),
    ),
    PageSize: z.optional(
      z.coerce
        .number()
        .int()
        .describe("Quantidade de itens por página. Padrão: 20."),
    ),
  })
  .optional() as unknown as ToZod<GetApiV1BannerClassStudentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BannerClassStudents200Schema = z.lazy(
  () => bannerClassStudentDropDownViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1BannerClassStudents200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BannerClassStudents401Schema =
  z.any() as unknown as ToZod<GetApiV1BannerClassStudents401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BannerClassStudents500Schema =
  z.any() as unknown as ToZod<GetApiV1BannerClassStudents500>;

export const getApiV1BannerClassStudentsQueryResponseSchema = z.lazy(
  () => getApiV1BannerClassStudents200Schema,
) as unknown as ToZod<GetApiV1BannerClassStudentsQueryResponse>;
